module.exports = __webpack_public_path__ + "static/podcast3-30e208cbf0774eb28bae72be8c325ad0.jpg";